"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tasks = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var Tasks = function Tasks() {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.89001 4.87555C4.34653 4.87555 3.9 5.31964 3.9 5.86014V17.1203C3.9 17.6608 4.34653 18.1049 4.89001 18.1049H15.5101C16.0535 18.1049 16.5001 17.6608 16.5001 17.1203V5.86014C16.5001 5.31964 16.0535 4.87555 15.5101 4.87555H14.5561V3.98047H15.5101C16.5506 3.98047 17.4001 4.8253 17.4001 5.86014V17.1203C17.4001 18.1551 16.5506 18.9999 15.5101 18.9999H4.89001C3.84948 18.9999 3 18.1551 3 17.1203V5.86014C3 4.8253 3.84948 3.98047 4.89001 3.98047H5.92501V4.87555H4.89001Z",
      fill: "#383745"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.82551 2.87072C8.07903 1.78253 9.1118 1 10.3085 1C11.5052 1 12.538 1.78253 12.7915 2.87072H13.3595C14.103 2.87072 14.7095 3.47388 14.7095 4.21334V5.0574C14.7095 5.79687 14.103 6.40003 13.3595 6.40003H7.05948C6.31595 6.40003 5.70947 5.79687 5.70947 5.0574V4.21334C5.70947 3.47388 6.31595 2.87072 7.05948 2.87072H7.82551ZM8.69742 3.09446C8.60918 3.53852 8.19186 3.7658 7.83348 3.7658H7.05948C6.81301 3.7658 6.60948 3.96822 6.60948 4.21334V5.0574C6.60948 5.30253 6.81301 5.50494 7.05948 5.50494H13.3595C13.606 5.50494 13.8095 5.30253 13.8095 5.0574V4.21334C13.8095 3.96822 13.606 3.7658 13.3595 3.7658H12.7835C12.3993 3.7658 12.0061 3.51577 11.9199 3.09599C11.7778 2.43426 11.1299 1.89508 10.3085 1.89508C9.48771 1.89508 8.84022 2.43343 8.69742 3.09446Z",
      fill: "#383745"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.7002 8.74051C5.7002 8.49334 5.90167 8.29297 6.1502 8.29297H9.75022C9.99874 8.29297 10.2002 8.49334 10.2002 8.74051C10.2002 8.98768 9.99874 9.18805 9.75022 9.18805H6.1502C5.90167 9.18805 5.7002 8.98768 5.7002 8.74051Z",
      fill: "#383745"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.5933 7.46083C14.7594 7.64464 14.7443 7.92761 14.5595 8.09286L12.6875 9.76666C12.5232 9.91353 12.2761 9.92012 12.1041 9.78222L11.2671 9.11091C11.0737 8.95575 11.0433 8.67399 11.1993 8.48159C11.3554 8.28919 11.6387 8.259 11.8321 8.41416L12.3708 8.8462L13.9578 7.42723C14.1426 7.26198 14.4271 7.27702 14.5933 7.46083Z",
      fill: "#5750FA"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.7002 12.3264C5.7002 12.0793 5.90167 11.8789 6.1502 11.8789H9.75022C9.99874 11.8789 10.2002 12.0793 10.2002 12.3264C10.2002 12.5736 9.99874 12.774 9.75022 12.774H6.1502C5.90167 12.774 5.7002 12.5736 5.7002 12.3264Z",
      fill: "#383745"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.5933 11.039C14.7594 11.2228 14.7443 11.5057 14.5595 11.671L12.6875 13.3448C12.5232 13.4917 12.2761 13.4982 12.1041 13.3603L11.2671 12.689C11.0737 12.5339 11.0433 12.2521 11.1993 12.0597C11.3554 11.8673 11.6387 11.8371 11.8321 11.9923L12.3708 12.4243L13.9578 11.0054C14.1426 10.8401 14.4271 10.8551 14.5933 11.039Z",
      fill: "#5750FA"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.7002 15.9046C5.7002 15.6574 5.90167 15.457 6.1502 15.457H9.75022C9.99874 15.457 10.2002 15.6574 10.2002 15.9046C10.2002 16.1517 9.99874 16.3521 9.75022 16.3521H6.1502C5.90167 16.3521 5.7002 16.1517 5.7002 15.9046Z",
      fill: "#383745"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.5933 14.6171C14.7594 14.8009 14.7443 15.0839 14.5595 15.2491L12.6875 16.9229C12.5232 17.0698 12.2761 17.0764 12.1041 16.9385L11.2671 16.2672C11.0737 16.112 11.0433 15.8302 11.1993 15.6378C11.3554 15.4454 11.6387 15.4153 11.8321 15.5704L12.3708 16.0024L13.9578 14.5835C14.1426 14.4182 14.4271 14.4333 14.5933 14.6171Z",
      fill: "#5750FA"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M10.2005 3.81696C10.449 3.81696 10.6505 3.61659 10.6505 3.36942C10.6505 3.12225 10.449 2.92188 10.2005 2.92188C9.95196 2.92188 9.75049 3.12225 9.75049 3.36942C9.75049 3.61659 9.95196 3.81696 10.2005 3.81696Z",
      fill: "#383745"
    })]
  });
};
exports.Tasks = Tasks;